module.exports = __webpack_public_path__ + "media/icons/biznes@2x-ab4ace44.png";